import { DataLockerEventBuckets } from '@/components/dataLocker/vis/DataLockerEventBuckets';
import { DataLockerEventMap } from '@/components/dataLocker/vis/DataLockerEventMap';
import { DataLockerHeatMap } from '@/components/dataLocker/vis/DataLockerHeatMap';

export const dataLockerVisualisationComponents = {
  heatMap: DataLockerHeatMap,
  eventMap: DataLockerEventMap,
  passSonar: DataLockerEventMap,
  shotMap: DataLockerEventMap,
  eventBuckets: DataLockerEventBuckets,
};
